import useGlobalContext from "globalProviders/GlobalDataProvider";
import { useQuery } from "react-query";
import { Box } from "@mui/material";
import SummarySkeleton from "./SummarySkeleton";
import { RoundedBox } from "@knowfully/ui.common";

export default function SummaryPage() {
  const { facultyService } = useGlobalContext();

  const {
    data: facultyResponse,
    isFetching: isFetchingFaculty,
    isFetched: isFetchedFaculty,
  } = useQuery(["getSummary"], () => facultyService.getSummary(), {
    keepPreviousData: true,
  });

  return (
    <>
      {isFetchingFaculty && (
        <RoundedBox>
          <SummarySkeleton />
        </RoundedBox>
      )}

      {isFetchedFaculty && (
        <RoundedBox>
          <Box
            dangerouslySetInnerHTML={{
              __html: facultyResponse?.renderedTemplate ?? "",
            }}
          />
        </RoundedBox>
      )}
    </>
  );
}
